export const haveIntersection = (r1, r2, margin = 0) => {
  return !(
    r2.x > r1.x + r1.width + margin ||
    r2.x + r2.width + margin < r1.x ||
    r2.y > r1.y + r1.height + margin ||
    r2.y + r2.height + margin < r1.y
  )
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/haveIntersection.js